import React from 'react';

const DashboardSkeleton = ({ isDarkMode }) => {
  const theme = {
    bg: isDarkMode ? '#050505' : '#f4f4f4',
    card: isDarkMode ? '#111' : '#fff',
    shimmer: isDarkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
    shimmerAccent: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'
  };

  const styleTag = `
    @keyframes shimmer {
      0% { background-position: -200% 0; }
      100% { background-position: 200% 0; }
    }
    .skeleton-box {
      background: linear-gradient(90deg, ${theme.shimmer} 25%, ${theme.shimmerAccent} 50%, ${theme.shimmer} 75%);
      backgroundSize: 200% 100%;
      animation: shimmer 1.5s infinite linear;
      borderRadius: 12px;
    }
    .fade-in {
      animation: fadeIn 0.4s ease-out forwards;
    }
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(5px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;

  return (
    <div style={{ background: theme.bg, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <style>{styleTag}</style>
      
      {/* 🚀 PERFECT MATCH HEADER (65px sticky shell) */}
      <div style={{ height: '65px', background: theme.card, borderBottom: `1px solid ${isDarkMode ? '#333' : '#ddd'}`, display: 'flex', alignItems: 'center', padding: '0 25px', justifyContent: 'space-between' }}>
         <div className="skeleton-box" style={{ width: '120px', height: '24px' }} />
         <div style={{ display: 'flex', gap: '15px' }}>
            <div className="skeleton-box" style={{ width: '35px', height: '35px', borderRadius: '50%' }} />
            <div className="skeleton-box" style={{ width: '35px', height: '35px', borderRadius: '50%' }} />
         </div>
      </div>

      {/* 🚀 PERFECT MATCH CONTENT AREA */}
      <div style={{ padding: '0 30px 100px 30px', flex: 1 }} className="fade-in">
        
        {/* 1. Stat Cards Row (Flex, gap 8px) */}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '8px 0 16px 0', marginBottom: '10px' }}>
          {[1,2,3,4,5].map(i => (
            <div key={i} className="skeleton-box" style={{ flex: 1, height: '42px', borderRadius: '14px' }} />
          ))}
        </div>

        {/* 2. Main Fleet Container (Inner background effect) */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '15px', 
          padding: '15px', 
          background: isDarkMode ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.02)', 
          borderRadius: '20px',
          border: `1px solid ${isDarkMode ? '#222' : '#e4e6e9'}`
        }}>
           {[1, 2, 3, 4].map(i => (
             <div key={i} className="skeleton-box" style={{ height: '85px', borderRadius: '18px' }} />
           ))}
        </div>

        {/* 3. Small Bottom Spacer */}
        <div className="skeleton-box" style={{ width: '100%', height: '150px', marginTop: '20px', borderRadius: '20px' }} />
      </div>

      {/* Bottom Nav Shell */}
      <div style={{ height: '70px', background: theme.card, borderTop: `1px solid ${isDarkMode ? '#333' : '#ddd'}` }} />
    </div>
  );
};

export default DashboardSkeleton;
